import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

const testimonials = () => {
    new Swiper('.swiper-container-testimonials', {
        modules: [Navigation, Pagination, Autoplay],
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 3000,
        },
        speed: 1200,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-testimonials-next',
            prevEl: '.swiper-testimonials-prev',
        },
    });
};

export { testimonials as default };
